import { SpaceEnums, Spaces } from '@oy/uicore';
import { createElement, CSSProperties, HTMLProps, ReactNode } from 'react';
import { assignPixelToSpacing as addPx } from '../../Token';

export type PadderProps = {
  all?: SpaceEnums;
  left?: SpaceEnums;
  right?: SpaceEnums;
  top?: SpaceEnums;
  bottom?: SpaceEnums;
  horizontal?: SpaceEnums;
  vertical?: SpaceEnums;
  tag?: 'div' | 'span';
  children?: ReactNode;
} & HTMLProps<HTMLDivElement | HTMLSpanElement>;

function mapPropsToPaddingStyle(props: PadderProps): CSSProperties {
  const style: CSSProperties = {};

  if (props.all) {
    style.padding = addPx(Spaces[props.all]);
  }

  if (props.horizontal && !props.vertical) {
    style.paddingLeft = addPx(Spaces[props.horizontal]);
    style.paddingRight = addPx(Spaces[props.horizontal]);
  }

  if (!props.horizontal && props.vertical) {
    style.paddingTop = addPx(Spaces[props.vertical]);
    style.paddingBottom = addPx(Spaces[props.vertical]);
  }

  if (props.horizontal && props.vertical) {
    style.paddingLeft = addPx(Spaces[props.horizontal]);
    style.paddingRight = addPx(Spaces[props.horizontal]);
    style.paddingTop = addPx(Spaces[props.vertical]);
    style.paddingBottom = addPx(Spaces[props.vertical]);
  }

  if (props.top) {
    style.paddingTop = addPx(Spaces[props.top]);
  }

  if (props.right) {
    style.paddingRight = addPx(Spaces[props.right]);
  }

  if (props.bottom) {
    style.paddingBottom = addPx(Spaces[props.bottom]);
  }

  if (props.left) {
    style.paddingLeft = addPx(Spaces[props.left]);
  }

  return style;
}

function Padder({ tag, children, ...props }: PadderProps) {
  const style = {
    ...(props.style || {}),
    ...mapPropsToPaddingStyle(props),
  };

  return createElement(
    tag || 'div',
    {
      ...props,
      style,
    },
    children,
  );
}

export default Object.assign(Padder, { Size: SpaceEnums });
